<template>
  <ContextColorProvider class="portfolio" context="wealth">
    <NavBar>
      <template #left>
        <BackButton @click="handleGoBackClick" />
      </template>
    </NavBar>
    <main class="portfolio__main">
      <Header
        class="portfolio__header"
        :is-loading="isHeaderLoading"
        :portfolio-name="portfolioName"
      />
      <Tabs
        class="portfolio__tabs"
        :current-tab-index="currentTabIndex"
        :selected-year="selectedYear"
        :year-options="yearOptions"
        :is-loading="isHeaderLoading"
        @on-change-year="onChangeYear"
        @on-change-tab="onChangeTab"
      />
      <div>
        <Statements
          v-if="currentTabIndex === TabsIndexes.Statements"
          :portfolio-id="portfolioId"
          :selected-year="selectedYear"
          @on-load="setHeaderInfo"
        />
        <BrokerageNotes
          v-if="currentTabIndex === TabsIndexes.BrokerageNotes"
          :portfolio-id="portfolioId"
          :selected-year="selectedYear"
          @on-load="setHeaderInfo"
        />
      </div>
    </main>
  </ContextColorProvider>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import { NavBar, ContextColorProvider } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { Header } from './components/Header';
import { Statements } from './components/Statements';
import { BrokerageNotes } from './components/BrokerageNotes';
import { Tabs } from './components/Tabs';

import { PortfolioMontlhyStatementListFilterOption } from '@/modules/wealth/services/portfolio';
import { TabsIndexes } from './types';

const route = useRoute();
const router = useRouter();

const currentTabIndex = ref<TabsIndexes>(TabsIndexes.Statements);
const portfolioName = ref<string | null>(null);
const isHeaderLoading = ref(true);
const selectedYear = ref<number | string | null>(null);
const yearOptions = ref<PortfolioMontlhyStatementListFilterOption[]>([]);

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

const onChangeTab = (tabIndex: TabsIndexes) => {
  currentTabIndex.value = tabIndex;
};

const onChangeYear = (newSelectedYear: number | string) => {
  selectedYear.value = newSelectedYear;
};

const setHeaderInfo = (
  newPortfolioName?: string | null,
  newSelectedYear?: number | string,
  newYearOptions?: PortfolioMontlhyStatementListFilterOption[]
) => {
  if (newPortfolioName) {
    portfolioName.value = newPortfolioName;
  }
  if (newSelectedYear) {
    selectedYear.value = newSelectedYear;
  }
  if (newYearOptions) {
    yearOptions.value = newYearOptions;
  }

  isHeaderLoading.value = false;
};

const handleGoBackClick = () => {
  router.replace({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
};
</script>

<style lang="less" scoped>
.portfolio {
  &__header {
    max-width: calc(800px + 2 * @size-spacing-x400);
    width: 100%;
    margin: 0 auto;
    padding: @size-spacing-x600 @size-spacing-x400 @size-spacing-x500
      @size-spacing-x400;

    .from-md({
      max-width: calc(800px + 2 * @size-spacing-x800);
      padding: @size-spacing-x800 @size-spacing-x800 @size-spacing-x500 @size-spacing-x800;
    });
  }

  &__tabs {
    max-width: calc(800px + 2 * @size-spacing-x400);
    width: 100%;
    margin: 0 auto;
    padding: 0 @size-spacing-x400;

    .from-md({
      max-width: calc(800px + 2 * @size-spacing-x800);
      padding: 0 @size-spacing-x800;
    });
  }
}
</style>
